export default function BasketFunctions() {

    //clickHandlers();

    checkoutSummary();

    const basketNotificationMessage = document.querySelector('.basket-notification');
    let addTobasketBtns = document.querySelectorAll('.add-to-basket');
    let saveColourBtns = document.querySelectorAll('.save-colour');
    let removeColourBtns = document.querySelectorAll('.remove-colour');
    const addAllBtn = document.getElementById('addAllChips');
    AddToBasketBindings();

    function AddToBasketBindings() {
        addTobasketBtns.forEach(element => {

            element.addEventListener('click', function (e) {

                e.preventDefault();

                let href = element.getAttribute("href");


                //for link add buttons
                fetch(href, {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(response => response.json())
                .then(data => {

                    document.querySelectorAll('.site-header__cart-count').forEach(element => {
                        element.innerHTML = data.totalItems;
                    });

                    if (basketNotificationMessage) {
                        basketNotificationMessage.classList.add('active');
                        basketNotificationMessage.querySelector('.content p').textContent = data.message;
                        basketNotificationMessage.querySelector('.icon-chip').style.color = data.iconColour
                        hideBasketMessage(basketNotificationMessage);
                    }

                    if (data.basket != "") {
                        document.querySelector('.basket').innerHTML = data.basket;
                    }

                    if (addAllBtn) {
                        addAllBtn.classList.remove('transparent');
                        document.querySelector('.loader').style.display = "none";
                    }

                })
                .catch(error => {


                    if (basketNotificationMessage) {
                        basketNotificationMessage.classList.add('active-error');
                        basketNotificationMessage.querySelector('.content').textContent = data.message;

                        hideBasketMessage(basketNotificationMessage);
                    }

                        if (addAllBtn) {
                            addAllBtn.classList.remove('transparent');
                            document.querySelector('.loader').style.display = "none";
                        }
                    })
                    .finally();
            });

        });
    }
    saveColourBtns.forEach(element => {

        element.addEventListener('click', function (e) {

            e.preventDefault();

            let href = element.getAttribute("href");


            //for link add buttons
            fetch(href, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => response.json())
                //.then(data => {          })
                .finally();
        });

    });

    removeColourBtns.forEach(element => {

        element.addEventListener('click', function (e) {

            e.preventDefault();

            let href = element.getAttribute("href");


            //for link add buttons
            fetch(href, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => response.json())
                //.then(data => {          })
                .finally();
        });

    });
    function sendAddToDataLayer(addResponse) {
        window.dataLayer = window.dataLayer || [];

        let items = [];
        for (var x = 0; x < addResponse.updatedItems; x++) {
            let thisItem = {};
            items.push();
        }

        dataLayer.push({
            'event': 'add_to_cart',
            'value': 0,
            'currency': addResponse.currencyCode,
            'items': items
        });


    }

    function hideBasketMessage(elem) {
        setTimeout(function () {
            elem.classList.remove("active");
            if (addAllBtn) {
                addAllBtn.classList.remove('transparent');
                document.querySelector('.loader').style.display = "none";
            }
        }, 5000);
    }

    if (basketNotificationMessage.classList.contains('active')) {
        hideBasketMessage(basketNotificationMessage)
    }

    let basketNotificationMessageClose = basketNotificationMessage.querySelector('.basket-notification__close');

    if(basketNotificationMessageClose) {
        basketNotificationMessageClose.addEventListener("click", function (e) {
            basketNotificationMessage.classList.remove('active');
        });
    }

    function removeFromBasket() {
        let removebasketItem = document.querySelectorAll('.basket-remove-item');

        removebasketItem.forEach(function (btn) {
            btn.addEventListener('click', function (e) {

                e.preventDefault();

                //for link add buttons
                fetch(e.target.getAttribute("href"), {
                        method: 'GET',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        let bsketCount = document.querySelectorAll('.site-header__cart-count');

                        bsketCount.forEach(element => {
                            element.innerHTML = data.totalItems;
                        });
                        document.querySelector('.basket').innerHTML = data.basket;
                        removeFromBasket();
                    })
                    .catch(error => console.log(error.message))
                    .finally();

            });
        });
    }

    removeFromBasket();

    // function setBasketContent(json, removeBtn, containerTarget) {

    //     let bsketCount = document.querySelector('.site-header__cart-count');

    //     bsketCount.textContent = json.totalItems;
    //     if (json.totalItems == 0) {
    //         let newMarkup = document.createElement('div');
    //         newMarkup.innerHTML = json.basket.trim();
    //         document.querySelector('.basket').replaceWith(newMarkup.firstChild);
    //     }
    // }

    function setBasketSummaryContent(json) {
        document.querySelectorAll('.site-header__cart-count').forEach(element => {
            element.innerHTML = json.totalItems;
        });

        //let basketNotificationMessage = document.querySelector('.basket-notification');

        //setTimeout(function () {
        //    basketNotificationMessage.classList.add('active');
        //}, 50);

        //setTimeout(function () {
        //    basketNotificationMessage.classList.remove('active');
        //}, 3050);
    }

    function checkoutSummary() {
        var toggleBtn = document.getElementById('order-summary-toggle');

        if (toggleBtn) {
            toggleBtn.addEventListener('click', function () {
                let summary = document.getElementById('order-summary').classList;
                var chevron = document.querySelector('.order-summary-arrow').classList;
                summary.toggle('active');
                chevron.toggle('rotate');
            });
        }
    }
}